import {AsyncQueue}     from "@Common/react/async-queue/async-queue";
import {cs}             from "@Common/react/chain-services";
import {consumeContext} from "@Common/react/context";
import {keyed}          from "@Common/react/keyed";
import {Load}           from "@Common/react/load";
import {Load2}          from "@Common/react/load2";

import {ApmPrefsLayout} from "./common/apm-prefs-layout";
import {ApmPrefsPanel}  from "./common/apm-prefs-panel/apm-prefs-panel";

export const ApmPrefsRoute = ({match}) => cs(
    ({}, next) => ApmPrefsLayout({
        activeTab: match.params.product,
        next,
    }),

    consumeContext("apis"),

    ["mailingLists", ({apis}, next) => Load2({
        fetch: () => apis.next.mailing.getMailingLists(),
        next,
    })],
    ["store", ({apis}, next) => cs(
        ["data", ({}, next) => Load2({
            fetch: () => apis.listings.getCleanUserPrefs(),
            next,
        })],
        ["queue", ({data}, next) => AsyncQueue({
            data,
            next,
        })],
        ({data, queue}) => next({
            prefs: data.value,
            dispatch: queue.pushAction,
        }),
    )],


    ["programPrefs", ({apis}, next) => cs(
        ["prefs", ({}, next) => Load2({
            fetch: () => apis.listings.getProgramPrefs(),
            next,
        })],
        ["prefs", ({prefs}, next) => prefs.loading ? (
            "Loading program..."
        ) : (
            next(prefs.value)
        )],
        consumeContext("session"),
        ({prefs, session}) => next(
            prefs.find((p) => p.program.idBranch === session.value.branchId)?.program
        ),
    )],

    ["styleTemplates", ({apis, programPrefs}, next) => Load({
        fetch: () => apis.next.getStyleTemplate([programPrefs.programPreferences.subCategoryID]),
        next,
    })],

    keyed(match.params.product),
    ({programPrefs, store, mailingLists, styleTemplates}) => ApmPrefsPanel({
        ...routes[match.params.product],
        styleTemplates,
        programPrefs,
        store,
        mailingLists,
    }),
);

const routes = {
    "postcards": ({
        productLabel: "Postcards",
        product: "postcards",
        quantities: true,
        coating: true,
        mailing: true,
    }),
    "brochures": ({
        productLabel: "Brochures",
        product: "brochures",
        quantities: true,
        coating: true,
        mailing: false,
    }),
    "flyers": ({
        productLabel: "Flyers",
        product: "flyers",
        quantities: true,
        coating: true,
        mailing: false,
    }),
    "social-media": ({
        productLabel: "Social Media",
        product: "socialMedia",
        quantities: false,
        defaultUrl: true,
    }),
};
